<template>
  <div class="product-display-display">
    <div class="product-display-info">
      <div class="main-steppers">
        <TButton
          :nav="true"
          :buttonClass="'Details'"
          @click="changeActive1('DetailsSection')"
          :textual="true"
          :label="$translation($websiteText().product_details_product_details)"
          :color="
            $store.getters.productActiveComponent === 'DetailsSection'
              ? '#034141'
              : '#3a3f40'
          "
          :style="{
            borderBottom:
              $store.getters.productActiveComponent === 'DetailsSection'
                ? '3px solid var(--app-primary-color) !important'
                : '',
          }"
        ></TButton>
        <span playwright-id="messages-tab">
          <TButton
            v-if="$store.getters.productDetailsInfos.availibilityId != 1 && (($store.getters.customer&&productDetailsInfos.sellerId != $store.getters.customer.id)||!$store.getters.customer) && $store.getters.productDetailsInfos.is_negotiable"
            :nav="true"
            :buttonClass="'Specs'"
            @click="changeActive1('DialogSection')"
            :textual="true"
            :label="$translation($websiteText().product_details_negotiations)"
            :color="
              $store.getters.productActiveComponent === 'DialogSection'
                ? '#034141'
                : '#3a3f40'
            "
            :style="{
              borderBottom:
                $store.getters.productActiveComponent === 'DialogSection'
                  ? '3px solid var(--app-primary-color) !important'
                  : '',
            }"
          ></TButton>
        </span>
      </div>

      <div class="infos">
        <div
          class="pricipal-infos"
          v-if="$store.getters.productActiveComponent === 'DetailsSection'"
        >
          <div class="images">
            <div @click="openFullSizeImage()" class="image-display-mobile">
              <img
                v-if="!showVideo"
                style="
                  object-fit: cover;
                  max-width: 100%;
                  max-height: 100%;
                  margin: 15px;
                  cursor: pointer;
                "
                :src="selected.thumb_url || selected.url"
              />

              <div
                style="margin: 25px"
                v-if="productDetailsInfos.youtubelink && showVideo"
              >
                <iframe
                  width="100%"
                  height="314"
                  :src="
                    'https://www.youtube.com/embed/' +
                    productDetailsInfos.youtubelink.substr(
                      productDetailsInfos.youtubelink.indexOf('=') + 1
                    )
                  "
                  title="YouTube video player"
                  frameborder="0"
                  allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                  allowfullscreen
                ></iframe>
              </div>
            </div>

            <div class="all-images">
              <div v-for="item in productDetailsImages" :key="item">
                <img
                  @click="
                    select(item);
                    toggleVideoVisiblity(false);
                  "
                  v-if="selected.id === item.id && item.file_type_id==1"
                  :class="'seleted-image'"
                  :src="item.url"
                  :alt="productDetailsInfos.title + '_selected'"
                  style="height:85px;"
                />
                <img
                  @click="
                    select(item);
                    toggleVideoVisiblity(false);
                  "
                  v-else-if = "selected.id !== item.id && item.file_type_id==1"
                  :class="'not-seleted-image'"
                  :alt="productDetailsInfos.title + '_not_selected'"
                  :src="item.url"
                  style="height:85px;"
                />


                <video
                  @click="
                    select(item);
                    toggleVideoVisiblity(false);
                  "
                  v-if="selected.id === item.id && item.file_type_id==3"
                  :class="'seleted-image'"
                  :src="item.url"
                  :alt="productDetailsInfos.title + '_selected'"
                  style="height:85px;"
                >
                  <source :src="item.url" >
                  Your browser does not support the video tag.
                </video>

                <video
                  @click="
                    select(item);
                    toggleVideoVisiblity(false);
                  "
                  v-else-if="selected.id !== item.id && item.file_type_id==3"
                  :class="'not-seleted-image'"
                  :src="item.url"
                  :alt="productDetailsInfos.title + '_selected'"
                  style="height:85px;"
                >
                  <source :src="item.url" >
                  Your browser does not support the video tag.
                </video>
                

                <img
                  :src="
                    'https://img.youtube.com/vi/' +
                    productDetailsInfos.youtubelink.substr(
                      productDetailsInfos.youtubelink.indexOf('=') + 1
                    ) +
                    '/1.jpg'
                  "
                  @click="toggleVideoVisiblity(true)"
                  v-if="productDetailsInfos.youtubelink"
                  :class="'not-seleted-image'"
                  style="width: 110px; height: 110px"
                />
              </div>
            </div>
            <div class="image-display">

              <div class="sold-ribbon ribbon-top-right" v-if="$store.getters.productDetailsInfos.availibilityId==1"><span>{{ $translation($websiteText().product_details_sold) }}</span></div>
              <div v-if="parseFloat(productDetailsInfos.salesPercentage) && productDetailsInfos.availibilityId != 1" class="salesPercentageTag">
                  <!-- {{ -formatPrice(productDetailsInfos.salesPercentage) }}% -->
                  SALE
              </div>
              <img
                v-if="!showVideo && selected.file_type_id ==1"
                @click="openFullSizeImage()"
                style="
                  max-width: 100%;
                  max-height: 100%;
                  margin: 15px;
                "
                :src="selected.thumb_url || selected.url"
                :style="$store.getters.productDetailsInfos.availibilityId==1?'opacity:0.5':'opacity:1'"
                :alt="productDetailsInfos.title"
                id="img"
                :key="selected.id"
              />

              <video
                  v-if="!showVideo && selected.file_type_id==3"
                  style="
                  max-width: 100%;
                  max-height: 100%;
                  margin: 15px;
                  "
                  :style="$store.getters.productDetailsInfos.availibilityId==1?'opacity:0.5':'opacity:1'"
                  :alt="productDetailsInfos.title"
                  id="img"
                  :key="selected.id"
                  controls
                  autoplay
                  muted
                >
                  <source :src="selected.thumb_url || selected.url" >
                  Your browser does not support the video tag.
                </video>

              <div
                style="margin: 25px"
                v-if="productDetailsInfos.youtubelink && showVideo"
              >
                <iframe
                  width="100%"
                  height="314"
                  :src="
                    'https://www.youtube.com/embed/' +
                    productDetailsInfos.youtubelink.substr(
                      productDetailsInfos.youtubelink.indexOf('=') + 1
                    )
                  "
                  title="YouTube video player"
                  frameborder="0"
                  allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                  allowfullscreen
                ></iframe>
              </div>
            </div>

            <FullSizeImageViewer
              :src="selectImageFullSize"
              v-model:is-active="viewFullSize"
            />
          </div>
        </div>
        <div v-else class="chat-div">
          <p-chat></p-chat>
        </div>

        <div class="more-infos">
          <div class="pricipal-info">
            <div
              class="top-info"
              v-if="$store.getters.productDetailsInfos.availibilityId != 1"
            >
              <div class="views" v-if="productDetailsInfos.watch_list">
                {{ productDetailsInfos.watch_list }}
                {{$translation($websiteText().product_details_favourites)}}
                <img :src="$config.favoriteSmallOrange" />
              </div>

              <div class="views">
                {{ productDetailsInfos.views }}
                {{ $translation($websiteText().product_details_views) }}
                <img :src="$config.viewsSmallOrange" />
              </div>
            </div>

            <div class="main-info">
              <div class="title">
                {{
                  productDetailsInfos.title == null
                    ? productDetailsInfos.condition +
                      " " +
                      Brand +
                      " " +
                      $translation(productDetailsInfos.Category)
                    : $translation(productDetailsInfos.title)
                }}
                <span v-if="Year">-</span>
                {{ Year }}
              </div>
              <div class="brand">{{ $translation(Brand) }} <span v-if="ProductName">-</span> {{ $translation(ProductName) }}</div>
              <div class="category">{{ $translation(productDetailsInfos.Category) }}</div>
              <div class="store">{{ productDetailsInfos.store }}</div>

              <div class="price-condition">
                <div v-if="productDetailsInfos.availibilityId != 1" class="price" :style="parseFloat(productDetailsInfos.salesPercentage)?'color:grey;text-decoration: line-through;':''">
                  {{ $store.getters.currency.symbol }}
                  {{ formatPrice(productDetailsInfos.price) }}
                  
                </div>

                <div v-if="productDetailsInfos.availibilityId != 1 && parseFloat(productDetailsInfos.salesPercentage)" class="price">
                  {{ $store.getters.currency.symbol }}
                  {{ formatPrice(productDetailsInfos.salesPrice) }}
                </div>
                <div v-if="productDetailsInfos.availibilityId != 1" style="font-size: 14px; font-weight: 500;">(tax excl.)</div>
              </div>

             
            </div>
            <div class="bottom-info">
              <div class="bottom-colonne1">
                <div class="type">
                  {{ $translation($websiteText().product_details_payment) }}
                </div>
                <div class="type type-mobile-margin">
                  {{ $translation($websiteText().product_details_delivery) }}
                </div>
              </div>
              <div class="bottom-colonne2">
                <div class="value-type">
                  <img style="margin-right: 20px" :src="$config.visaPaymentMethodLogo" />
                  <img
                    style="margin-right: 20px"
                    :src="$config.masterCardPaymentMethodLogo"
                  />
                  <img
                    style="margin-right: 20px"
                    :src="$config.payPalPaymentMethodLogo"
                  />
                </div>
                <div class="value-type">
                  <b>
                    <span>
                     {{productDetailsInfos.estimatedTime}}
                    </span>
                    
                  </b>
                  {{$translation($websiteText().product_details_after_payments)}}
                </div>
              </div>
            </div>

            <div class="returns" @click="goToPolicy()">{{$translation($websiteText().product_details_policy)}}</div>

          </div>
          
          <div class="add-to-cart-button">
            <div style="display: flex; gap: 10px;">

              <Quantity
                v-if="
                  $store.getters.productDetailsInfos.availibilityId != 1 &&
                  (($store.getters.customer &&
                    productDetailsInfos.sellerId != $store.getters.customer.id) ||
                    !$store.getters.customer) && productDetailsInfos.quantity>1
                "
                v-model="quantity"
                :min="1"
                :max="productDetailsInfos.quantity"
              />
              <TButton
                v-if="
                  $store.getters.productDetailsInfos.availibilityId != 1 &&
                  (($store.getters.customer &&
                    productDetailsInfos.sellerId != $store.getters.customer.id) ||
                    !$store.getters.customer)
                "
                :color="'primary-color'"
                buttonClass="add-to-cart-btn"
                :label="$translation($websiteText().product_details_add_to_cart)"
                @click="cartClick({kit:$store.getters.kitId,quantity:quantity,affiliate:$route.query.ref})"
                style="margin-bottom: 50px;"
              ></TButton>
            </div>

            <div 
              class="addanoffer"
              v-if="$store.getters.productActiveComponent != 'DialogSection' 
              && $store.getters.productDetailsInfos.availibilityId === 4 
              && (($store.getters.customer &&
                    productDetailsInfos.sellerId != $store.getters.customer.id) ||
                    !$store.getters.customer)
              && $store.getters.productDetailsInfos.is_negotiable
              ">
                <MakeOfferInput/>
            </div>
          </div>
        </div>
        
      </div>
    </div>

    <div class="info-table">

      <div class="description">
        <div style="display: flex; flex-direction: column; justify-content: space-between; height: 100%;">
            <div>
              <b>{{$translation($websiteText().product_details_items_description)}}</b>
              <br><br>
              <span v-html="$translation(description)"></span>
            </div>

            

            <div v-if="JSON.parse(productDetailsInfos.accessories).length">
              <br>
              <b>{{$translation($websiteText().product_details_items_accessories)}}</b>
              <br><br>
              <template v-for="accessory in JSON.parse(productDetailsInfos.accessories)" :key="accessory">
                  <li>{{ accessory }}</li>
              </template>
              
            </div>

            
            <div v-if="productDetailsInfos.files.length">
              <br>
              <b>{{ $translation($websiteText().product_details_items_files)}}</b>
              <br><br>
              <div v-for="file in productDetailsInfos.files" :key="file.url"> 
                <a :href="file.url" target="_blank" class="document-links" style="text-decoration: unset;">{{ file.name }} </a>
              </div>
            </div>
        </div>
      
        
      </div>
      <div class="specs">
        <b>{{$translation($websiteText().product_details_items_specifics)}}</b>
        <br><br>
        <Specs></Specs>
      </div>
    </div>
    <div class="info-table2">

      <div class="kitQA" :style="{width: productDetailsInfos.isTrustedSeller || productDetailsInfos.isCertifiedSeller ? '49%' : '100%'}">
        <KitQA :QAs="productDetailsInfos.kitQA||[]"/>
      </div>

      <div class="kitQAMobile" style="width: 100%;">
        <KitQA :QAs="productDetailsInfos.kitQA||[]"/>
      </div>

      <div class="shop-with" v-if="productDetailsInfos.isTrustedSeller || productDetailsInfos.isCertifiedSeller">
        <div style="margin-bottom: 20px;"><b>SHOP WITH CONFIDENCE</b></div>

        <div style="margin-bottom: 20px; display: flex;" v-if="productDetailsInfos.isTrustedSeller" >
          <img :src="$config.trustedSeller2" style="width:52px;"/>
          <div style="margin-left: 25px;">
            <span style="font-weight: 700;"> Trusted Seller</span><br>
            <div style="font-weight: 400;" v-if="productDetailsInfos.nbSuccessfullSales"> Has more than <b> {{ productDetailsInfos.nbSuccessfullSales - 1 }} </b> successful sales.</div>
          </div>
        </div>

        <div style="margin-bottom: 20px; display: flex;"  v-if="productDetailsInfos.isCertifiedSeller">
          <img :src="$config.certifiedSeller" style="width:62px;"/>
          <div style="margin-left: 15px;">
            <span style="font-weight: 700;"> Certified Seller</span><br>
            <div style="font-weight: 400;"> </div>
          </div>
        </div>

      </div>
      
    </div>
    
  </div>
</template>

<script>
import TButton from "../../../common/components/buttons/TButton.vue";
import useWatchList from "../../landing/hooks/useWatchList";
import store from "../../../store";
import {useRouter, useRoute} from "vue-router";
import {GET_SIMILAR, KIT_INC_VIEWS} from "../store/actions";
import GeneralHelper from "../../../common/helpers/GeneralHelper";
import TInputText from "../../../common/components/input-text/TInputText.vue";
import FullSizeImageViewer from "./FullSizeImageViewer.vue";
import {defineAsyncComponent} from "vue";
import {ADD_KIT_TO_CART, SWITCH_CART_DIALOG} from "../../checkout/store/actions";
import Specs from "./description-details-specs/Specs.vue";
import Quantity from '../../../common/components/controls/Quantity.vue'
import { ADD_KEYWORDS } from "../../../common/store/actions";

const PChat = defineAsyncComponent(() => import("./chat/Chat.vue"));
const Chat = defineAsyncComponent(() =>
  import(
    "../../product-details/components/productComunication/HeaderProductComunicationDesktop"
  )
);

import MakeOfferInput from "./MakeOfferInput.vue";
import KitQA from './KitQA.vue'
import translation from "../../../translations";

export default {
  components: {
    TButton,
    //TInputText,
    PChat,
    FullSizeImageViewer,
    MakeOfferInput,
    Specs,
    KitQA,
    Quantity
    
},
  data() {
    return {
      selected: {},
      selectedFullSize: {},
      viewFullSize: false,
      activeComponent1: "DetailsSection",
      showVideo: false,
      quantity:1,
      keywords:{
        preferences:[]
      }
    };
  },
  computed: {
    main_image() {
      return this.$store.getters.main_images;
    },
    kitUrl() {
      let kit = {
        id : this.$store.getters.kitId,
        brandName : this.$store.getters.productDetailsInfos.brand,
        categoryName : this.$store.getters.productDetailsInfos.Category,
        title : this.$store.getters.productDetailsInfos.title
      }
      return GeneralHelper.kitLink(kit)
    },
    productDetailsImages() {
      return this.$store.getters.productDetailsImages;
    },
    mainItem() {
      return this.$store.getters.productDetails.items.find((x) => x.is_main == true);
    },
    Brand() {
      let brandSpec = this.mainItem.product.specs.find((x) => x.name == "Brand");
      if (brandSpec) return brandSpec.values[0].value;
      return "";
    },
    Year() {
      let brandSpec = this.mainItem.product.specs.find((x) => x.name == "Year");
      if (brandSpec) return brandSpec.values[0].value;
      return "";
    },
    ProductName() {
      let brandSpec = this.mainItem.product.specs.find((x) =>
        x.name.toLowerCase().includes("name")
      );
      if (brandSpec) return brandSpec.values[0].value;
      return "";
    },
    productDetailsInfos() {
      return this.$store.getters.productDetailsInfos;
    },
    similarsItems() {
      return this.$store.getters.similarsItems;
    },
    productItemsSimiliar() {
      return this.$store.getters.productItemsSimiliar;
    },
    seller_Id() {
      return this.$store.getters.seller_Id;
    },
    selectImageFullSize() {
      let This = this;
      for (let i = 0; i < this.$store.getters.productDetailsFullSizeImages.length; i++) {
        if (This.selected.id == this.$store.getters.productDetailsFullSizeImages[i].id) {
          return this.$store.getters.productDetailsFullSizeImages[i].url;
        }
      }
      return null;
    },

   
    description() {
      if(this.$store.getters.description == undefined || this.$store.getters.description.length == 0) 
      return "No description."
      
      return this.$store.getters.description;
    },
  
  },
  mounted() {
    console.log(this.productDetailsInfos)
    this.keywords.preferences.push({ value: this.productDetailsInfos.categoryId , type:'category'})
    this.keywords.preferences.push({ value: this.productDetailsInfos.id, type: 'kit'})
    this.$store.dispatch(ADD_KEYWORDS, this.keywords)

    this.selected = this.$store.getters.main_images;
    this.$store.dispatch(KIT_INC_VIEWS, this.productDetailsInfos.id);
    this.$store.dispatch(GET_SIMILAR, this.productDetailsInfos.id);
    this.$nextTick(() => {});
    this.openChat(); 
  
  },

  watch: {
    main_image: {
      handler(newValue, oldValue) {
        this.selected = this.$store.getters.main_images;
      },
      deep: true,
    },
  },

  created() {},
  methods: {

    openChat(){
      const route = useRoute();
      if(route.query.chat){
        this.changeActive1('DialogSection')
      }
    },
    cartClick(data) {
      store.dispatch(ADD_KIT_TO_CART, data).then(()=>{

        store.dispatch(SWITCH_CART_DIALOG);
      });
    },

    toggleVideoVisiblity(state) {
      this.showVideo = state;
    },
    changeActive1(name) {
      if (name === "DialogSection") this.$store.dispatch("productActiveComponent", name);
      else this.$store.commit("productActiveComponent", name);
      this.activeComponent1 = name;
    },
    formatPrice(price) {
      return GeneralHelper.formatPice(price);
    },
    closeProductDetailsPopup() {
      $("body").css("overflow", "auto");
      this.$router.push({name: "equipment"});
    },
    saveSeller(sellerId) {
      store.dispatch("saveSeller", sellerId);
    },
    sameSeller(kitId) {
      store.dispatch("sameSeller", kitId).then(() => {
        this.$store.commit("displayProductDetails1", {option: false, id: ""});
        this.$router.push({name: "equipment"});
      });
    },
    select(item) {
      this.selected = item;
      
    },

    openFullSizeImage() {
      this.viewFullSize = true;
    },
    goToChat() {
      this.$store.dispatch("productDetailsActiveComponent", Chat);
    },

    goToPolicy() {
      this.$router.push({name: "terms"});
    },
  },
  setup() {
    const closeShare = () => {
      store.commit("setShowShare");
    };

   
    const router = useRouter();
    const {addToWatchList, removeFromWatchlist, kitExistInWatchList} = useWatchList();
    const openProductDetailsPopup = (ListingId) => {
      store.dispatch("getProductDetails", ListingId);
      router.push({name: "productDetails", params: {id: ListingId}});
      $(".auth-container").animate({scrollTop: 0}, 600);
    };
    const watchListClick = (kit) => {
      if (kitExistInWatchList(kit.id)) removeFromWatchlist(kit);
      else addToWatchList(kit);
    };
    return {
      openProductDetailsPopup,
      watchListClick,
      closeShare,
    };
  },

  watch: {
    "$store.getters.currency": {
      handler(newValue, oldValue) {
        if( newValue.id != oldValue.id)
          location.reload()
      },
      deep: true,
    },
  },
};
</script>

<style lang="scss" scoped>
@import "../style/ProductDetailsContaint.scss";

.document-links{
  text-decoration: none;
  color: black;
}

.document-links:hover{
  color: var(--app-primary-color);
}
</style>
